<template>
  <Modal :id="'cmp-catalog-tracks-new_track_credit'" @cancelled="onCancel">
    <template slot="header"
      >{{ title }} {{$t('track_credit')}}</template
    >
    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <Dropdown
            :id="'type'"
            class="m2"
            :options="trackCreditTypesTV"
            :selected="trackCreditTypesTV.find(e => e.value == track_info.type)"
            :placeholder="$t('type')"
            box
            @selectedChange="e => onDropdownChange('type', e)"
          ></Dropdown>

          <TextField
            :id="'name'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="track_info.name"
            isModel
            :placeholder="$t('name')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'percentage'"
            :type="'percent'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="track_info.percentage"
            isModel
            :placeholder="$t('share')"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { async } from "rxjs/internal/scheduler/async";
import { TracksService } from "../../services/tracks.service";
import { createTV } from "../../../../models/text-value.model";
import {
  createFormItemMixin,
  createFormModalMixin
} from "../../../../dt-plugins/form-modal/form-modal";

export default {
  components: {
    Modal,
    InputField,
    NTable
  },
  props: ["selectedTrackDetails"],
  mixins: [
    createFormModalMixin(),
    createFormItemMixin({
      primary_key: "track_info_id",
      itemKey: "track_info",
      detailsHttpReq: TracksService.detailsTrackInfo,
      addHttpReq: TracksService.newTrackCredit
    })
  ],
  computed: {
    trackCreditTypesTV: function() {
      return createTV(
        this.details && this.details.track_credit_types,
        "en",
        "key"
      );
    },
    track_id: function() {
      return this.$route.params.track_id;
    }
  },
  methods: {
    onOkClick: async function() {
      if (this.mode == "add") {
        const res = await TracksService.submitTrackCredit(
          this.track_id,
          this.selectedTrackDetails.track_credits.track_info_id,
          this.track_info.type,
          this.track_info.name,
          this.track_info.percentage
        );
        this.$emit("added", res.data);
      } else if (this.mode == "edit") {
        this.$emit("edited", this.track_info);
      }
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    get_track_info: function() {
      return {
        name: null,
        description: null,
        type: null,
        track_info_id: null,
        percentage: null
      };
    }
  }
};
</script>

<style lang="scss">
.cmp-catalog-tracks-search_product {
  .catalog-product_groups-add_products {
    border: 1px solid var(--sprt-5);
  }
}
</style>
